import { IRegistryDataTransport } from '../registry.types';
import { createException, RegistryErrorCode } from '../errors/RegistryError';

async function fetchUrl(url: string) {
  const response = await fetch(url);

  if (!response.ok) {
    throw createException('Fetch failed', RegistryErrorCode.FetchError);
  }

  return response;
}

export function createRegistryDataTransport(): IRegistryDataTransport {
  return {
    async fetchLibraryManifest(url: string) {
      const response = await fetchUrl(url);
      return response.json();
    },
    async fetchLibraryRuntime(url: string) {
      const response = await fetchUrl(url);
      return response.text();
    },
    async fetchLibraryHotBundle(url: string) {
      const response = await fetchUrl(url);
      return response.text();
    },
    async fetchComponentsBundle(url: string) {
      const response = await fetchUrl(url);
      return response.text();
    },
  };
}
